import React, { useEffect, useState, useDispatch } from "react";
import { Link } from "react-router-dom";
import SignUp from "./SignUp";
// import ReactGA from "react-ga";
import { ReactComponent as RadarrLogo } from "../../../assets/radarr-logo-green.svg";
import { ReactComponent as Chevron } from "../../../assets/svg/chevron.svg";
import connectingDots from "./connections-dots.png";
import productImage1 from "./product-img-1.webp";
import productImage2 from "./product-img-2.webp";
import award1 from "./award1.jpg";
import award2 from "./award2.jpg";
import award3 from "./award3.png";
import "./SignUpContainer.scss";
// import { updateRouteValues } from "../../../actions/globalAction";
import Login from "../Login";
import { ReactComponent as GSummit } from "./g2.svg";
import SignInTextContainer from "../../AppContainer/LeftContainer/SignInTextContainer";

const SignUpContainer = (props) => {
    useEffect(() => {
        zE("webWidget", "updateSettings", { color: { theme: "#00bfa3" } });
        zE("webWidget", "show");

        document.title = "Signup on Radarr - Best Social Listening Platform";

        return () => {
            zE("webWidget", "hide");
        };
    }, []);

    useEffect(() => {
        // console.log("kllkklkllkl",window.location.pathname)
        // let route = {
        //     to: window.location.pathname,
        //     from: prevProps.location.pathname,
        // };
        // this.props.updateRouteValues(route);
    }, [props]);

    const scrollTop = () => {
        window.scroll({ top: 0, left: 0, behavior: "smooth" });
    };

    return (
        <div className="signup-container">
            <div className="signup-main">
                <div className="signup-navbar">
                    <RadarrLogo />
                    {/* <Link to={window.location.pathname === "/signin" ? "/signup" : "/signin"}>
                        <div className="navbar-button">{window.location.pathname === "/signin" ? "Sign Up" : "Sign In"}</div>
                    </Link> */}
                </div>
                <div className="signup-contents">
                    <div className="signup-left">
                        <div className="signup__left-wrap">
                            {props.component === "SignUp" ? (
                                <TextContainer />
                            ) : (
                                // <div className="main-text">
                                //     <p className="main__para">A powerful</p>
                                //     <p className="sub__main">social media suite</p>
                                //     <p className="secondary__text">that helps you listen, monitor and respond to online conversations easily.</p>
                                // </div>
                                <SignInTextContainer />
                            )}

                            {/* <TextContainer /> */}
                        </div>
                    </div>
                    <div className="signup-right">
                        {/* <SignUp /> */}
                        {props.component === "SignUp" ? <SignUp /> : <Login />}
                    </div>
                    <div
                        className="scrolldown-indicator"
                        onClick={() => window.scrollBy({ top: document.documentElement.clientHeight, left: 0, behavior: "smooth" })}>
                        <Chevron />
                    </div>
                </div>
            </div>
            <div className="customers-section">
                <h3>Our Clients</h3>
                <p>Radarr helps 1000+ brands globally get actionable insights from social media data.</p>
                <div className="client-logos">
                    <span className="image-container">
                        <img alt="Discovery" src="https://www.radarr.com/wp-content/uploads/2022/02/discovery.svg" />
                    </span>
                    <span className="image-container">
                        <img alt="X" src="https://www.radarr.com/wp-content/uploads/2022/02/twitter.svg" />
                    </span>
                    <span className="image-container">
                        <img alt="Glico" src="https://www.radarr.com/wp-content/uploads/2022/02/glico.svg" />
                    </span>
                    <span className="image-container">
                        <img alt="Quantum" src="https://www.radarr.com/wp-content/uploads/2022/02/Quantum.svg" />
                    </span>
                    <span className="image-container">
                        <img alt="Toyota" src="https://www.radarr.com/wp-content/uploads/2022/02/toyota.svg" />
                    </span>
                    {/* <span className="image-container">
                        <img alt="Hong Leong Bank" src="https://www.radarr.com/wp-content/uploads/2022/02/hong_leong_bank.svg" />
                    </span> */}
                    <span className="image-container">
                        <img alt="Mapletree" src="https://www.radarr.com/wp-content/uploads/2022/02/mapletree.svg" />
                    </span>
                </div>
            </div>
            <div className="our-products">
                <div className="our-products-left">
                    <div className="our-products__left-wrap">
                        <div className="text-container">
                            <p className="main">Put social media</p>
                            <p className="sub">data and online conversations to work.</p>
                            <p className="text">
                                <span>Radarr</span> is a powerful social and digital listening platform that helps brands gather actionable insights about their
                                audience response, interests and market trends in a fuss-free way; in real-time.
                            </p>
                        </div>
                        {/* <div className="free-trial-button" onClick={scrollTop}>
                            <span>Start your free 7-day trial</span>
                        </div> */}
                        <div className="connecting-dots">
                            <img src={connectingDots} alt="connecting-dots-image" />
                        </div>
                    </div>
                </div>
                <div className="our-products-right">
                    <img src={productImage1} alt="connecting-dots-image" />
                </div>
            </div>
            <div className="our-performance">
                <div className="our-performance-left">
                    <div className="our-performance__left-wrap">
                        <div className="text-container">
                            <p className="sub">Keep track of content performance</p>
                            <p className="main">and optimize your budgets.</p>
                            <p className="text">
                                <span>The Radarr Command Center</span> brings all your important data points onto one dashboard. Offering real-time
                                visualizations of content and campaign performances to help give you insights to make it better.
                            </p>
                        </div>
                        {/* <div className="free-trial-button" onClick={scrollTop}>
                            <span>Start your free 7-day trial</span>
                        </div> */}
                    </div>
                </div>
                <div className="our-performance-right">
                    <img src={productImage2} alt="connecting-dots-image" />
                </div>
            </div>
            <div className="g__summit__container">
                <div className="left__block">
                    <GSummit />
                </div>
                <div className="g__summit__right__block">
                    <h3>{`We're High Performers!`}</h3>
                    <div>
                        <p className="g2__text">Our social media monitoring and analytics tool has earned the badge of high performers on G2.</p>
                        <p className="g2__text">
                            From helping you make the most of social media data to creating strategies that are designed to boost customer engagement across the
                            digital landscape, Radarr is here to do the heavy lifting for you.
                        </p>
                    </div>
                </div>
            </div>
            <div className="our-awards">
                <h3>Our Awards</h3>
                <div className="awards-list">
                    <div className="awards-list-item">
                        <img src={award2} alt="" />
                        <p>Winner Best MARKTECH Solution Social listening</p>
                        <p>2018</p>
                    </div>
                    <div className="awards-list-item">
                        <img src={award1} alt="" />
                        <p>GOLD AWARD Most Effective Use Social Media</p>
                        <p>2021</p>
                    </div>
                    <div className="awards-list-item">
                        <img src={award3} alt="" />
                        <p>GOLD Awards Best use of Social BRONZE Best Awareness Campaign</p>
                        <p>2021</p>
                    </div>
                </div>
            </div>
            <div className="client-reviews">
                <h3>Client Reviews</h3>
                <ClientReviews />
                {/* <div className="free-trial-button" onClick={scrollTop}>
                    <span>Start your free 7-day trial</span>
                </div> */}
            </div>
        </div>
    );
};

const texts = [
    {
        main: "Track every consumer",
        sub: "trend and sentiment",
        text: "Keep track of what’s trending across the globe. Scan consumer sentiments in real time and set up alerts to manage brand reputation.",
    },
    {
        main: "Turn online conversations",
        sub: "into brand insights",
        text: "Powered by AI, Radarr is the best social listening, monitoring and tracking platform that helps you get better results faster.",
    },
    {
        main: "Benchmark your performance",
        sub: "and find new opportunities",
        text: "Use our Al powered social analytics and intelligence tool to get in-depth analysis of your campaigns. Uncover untapped opportunities to get ahead!",
    },
    {
        main: "Track",
        sub: "competitors",
        text: "Simplified business intelligence with our intuitive competitor tracking platform. Have the information you need to be a step ahead.",
    },
];

const TextContainer = () => {
    const [index, setIndex] = useState(0);
    useEffect(() => {
        const interval = setInterval(() => {
            if (index === 3) setIndex(0);
            else setIndex(index + 1);
        }, 4000);

        return () => {
            clearInterval(interval);
        };
    }, [index]);

    return (
        <div className="TextContainer">
            <p className="main">{texts[index].main}</p>
            <p className="sub">{texts[index].sub}</p>
            <p className="text">{texts[index].text}</p>
        </div>
    );
};

const clients = [
    {
        name: "Discovery",
        review: "With real-time alerts and quick turn-around reports, Discovery has been able to jump on trends on many occassions, from COVID-19 lockdown behaviours, to trending food hacks. Consumer insights reports around relevant themes have also helped in content inspiration, from ideation to execution.",
        logo: "https://www.radarr.com/wp-content/uploads/2022/02/discovery.svg",
        type: "Trendspotting Content Inspiration",
        industry: "Entertainment",
    },
    {
        name: "Twitter",
        review: "Through social listening, we are able to help X identify the latest conversation themes people are tweeting about. By doing digital ethnography on tweets, Twitter is also able to map out changes in consumer behaviour such as in travel or entertainment. These insights are vital for brands to know how best to engage with their audience on X.",
        logo: "https://www.radarr.com/wp-content/uploads/2022/02/twitter.svg",
        type: "Consumer Insights",
        industry: "Technology",
    },
    {
        name: "Glico",
        review: "By analyzing the wealth of online conversations about Glico and its competitor brands, we are able to set benchmarks to help the brand gauge their campaigns’ performance. We have also developed a customized methodology to measure their Key Opinion Leaders’ (KOLs) performance. This helps them identify which influencers have provided them with the most ROI.",
        logo: "https://www.radarr.com/wp-content/uploads/2022/02/glico.svg",
        type: "Brand Audit",
        industry: "FMCG",
    },
    {
        name: "Quantum",
        review: "To expand on their research capabilities, Quantum CS couples the existing business of qualitative research with social listening to derive more meaningful insights and strategies for their clients. With Radarr’s insights team to help initiate and train them on social analytics methodologies, the team can focus on providing accurate findings that is in line with genuine consumer conversations online.",
        logo: "https://www.radarr.com/wp-content/uploads/2022/02/Quantum.svg",
        type: "Qualitative Research",
        industry: "Research",
    },
    {
        name: "Toyota",
        review: "As one of the global market leader within the automotive industry, Toyota’s “customer first” philosophy is deeply ingrained within the business – where understanding customer’s sentiment and point of view is crucial in their measurement of success. By detecting relevant mentions of the brand and its sentiment in local languages, the Radarr platform has been instrumental in helping the CX team overcome the challenges of understanding native customer sentiment and concerns in the APAC region.",
        logo: "https://www.radarr.com/wp-content/uploads/2022/02/toyota.svg",
        type: "Customer Experience",
        industry: "Automotive",
    },
    // {
    //     name: "Hong Leong Bank",
    //     review: "Real-time alerts, especially regarding negative mentions, have allowed Hong Leong Bank deal with crisis situations quickly. The team has also been on top of any banking industry related news by getting alerts for industry posts that received gained high traction.",
    //     logo: "https://www.radarr.com/wp-content/uploads/2022/02/hong_leong_bank.svg",
    //     type: "Crisis Management",
    //     industry: "Finance",
    // },
    {
        name: "Mapletree",
        review: "The myriad of buildings Mapletree owns in many parts of the world require a powerful social listening tool to monitor the happenings in one place, from possible riots happening in a building, to any COVID-19 exposure in a shopping mall. The automated alerts and reports allow the team in Mapletree to be on top of not only their own commercial buildings, but industry news from around the region.",
        logo: "https://www.radarr.com/wp-content/uploads/2022/02/mapletree.svg",
        type: "Crisis Management Industry News",
        industry: "Real Estate",
    },
];

const ClientReviews = () => {
    const [expanded, setExpanded] = useState(true);

    if (expanded)
        return (
            <div className="client-reviews-list">
                {clients.map((d) => (
                    <div key={d.name} className="client-review-item">
                        <div className="client-logo">
                            <img src={d.logo} alt={d.name} />
                        </div>
                        <div className="client-review-text">
                            <span>{d.review}</span>
                        </div>
                        <p className="client-industry">{d.industry}</p>
                        <p className="client-review-type">{d.type}</p>
                    </div>
                ))}
            </div>
        );
    else
        return (
            <>
                <div className="client-reviews-list">
                    {clients.slice(0, 3).map((d) => (
                        <div key={d.name} className="client-review-item">
                            <div className="client-logo">
                                <img src={d.logo} alt={d.name} />
                            </div>
                            <div className="client-review-text">
                                <span>{d.review}</span>
                            </div>
                            <p className="client-industry">{d.industry}</p>
                            <p className="client-review-type">{d.type}</p>
                        </div>
                    ))}
                </div>
                <p onClick={() => setExpanded(true)}>{`Read more clients reviews >`}</p>
            </>
        );
};

export default SignUpContainer;
